import React from 'react';

const FulfillmentGroupItemsPreview = ({ orderItems, showDeliveryMethod, fulfillmentGroup }) => {
  if (!orderItems || orderItems.length === 0) {
    return null; // Return null if no items, MessageContainer can decide spacing
  }

  // Get delivery method info if available and requested
  const deliveryMethodText = showDeliveryMethod && fulfillmentGroup ? 
    (fulfillmentGroup.groupType === 'shipping' ? 'Shipping' : 'Pickup') : null;

  return (
    <div className="w-full">
      {deliveryMethodText && (
        <div className="text-xs text-gray-500 mb-1.5 font-medium">
          {fulfillmentGroup.groupType === 'shipping' ? '📦 Shipping' : '🏬 Pickup'}
        </div>
      )}
      <div className="overflow-x-auto pb-1 -mx-2 px-2">
        <div className="flex space-x-2 min-w-min">
          {orderItems.map(item => {
            const product = item.product;
            const imageUrl = product?.photos?.[0]?.url || 'https://via.placeholder.com/80'; 

            return (
              <div 
                key={item.id} 
                className="flex-shrink-0 w-14 h-14 bg-gray-200 border border-gray-300 rounded-md shadow-sm overflow-hidden"
                title={product?.name || 'Product item'}
              >
                <img 
                  src={imageUrl} 
                  alt={product?.name || 'Item'} 
                  className="h-full w-full object-cover"
                />
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default FulfillmentGroupItemsPreview; 